import { render, staticRenderFns } from "./FormAddFilhos.vue?vue&type=template&id=31018d0d&scoped=true&"
import script from "./FormAddFilhos.vue?vue&type=script&lang=js&"
export * from "./FormAddFilhos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31018d0d",
  null
  
)

export default component.exports